import { addItemToCollection } from "directus/src/operations";

export async function createCategory({ item }) {
  try {
    const data = await addItemToCollection("survey_categories", item);
    return data;
  } catch (error) {
    console.log(error);
    throw error;
  }
}
